import React, { useState, useEffect } from "react";
import SideBar from "../common/sideBar";

import { axiosInstnace as Axios } from "../../../util/util";
import { endPoints } from "../../../config";
import { Input } from "../../common/input";
import { Field, reduxForm } from "redux-form";
import moment from "moment";
const EditCampaign = (props) => {
  const [handleCampaignList] = useState([]);
  const adminData = JSON.parse(localStorage.getItem("adminInfo"));

  useEffect(() => {
    getCampaignlist(0);
  }, []);

  const getCampaignlist = async (skip) => {
    try {
      const data = await Axios.get(endPoints.campaignList, {
        params: {
          skip,
        },
      });
      const result = data.data.data.data;
      if (result) {
        handleCampaignList(result);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div>
      <div className="dashboardContainer">
        <div className="navbar-header dashboard-header clearfix">
          <div className="logo-dashboard">
            <a id="logo">
              <img className="logo-trans" src="/assets/images/new_logo.png" />
            </a>
            <span>Welcome: {adminData.email} </span>
            <span>Last Login @ {moment(adminData.lastLogin).format("DD/MM/YYYY hh:mm A")}</span>
          </div>
          <div
            className="user-profile pull-right"
            tabIndex={0}
            onClick={() => {
              localStorage.removeItem("adminInfo");
              window.location.href = "/admin/login";
            }}
          >
            <a>
              <span>
                LOGOUT
                <span className="log_img">
                  <img src="/assets/images/ic_logout.png" />
                </span>
              </span>
            </a>
          </div>
        </div>
        <div className="dashboardContainer-inner">
          <section id="sidebar">
            <SideBar />
          </section>
          <section id="dashboard-rightContainer" className="dashboard-manageSales brands-head">
            <div className="createCamp-container">
              <div className="createCamp-main custom_coprate bg-white">
                <div className="campContainer">
                  <div class="campaignItem">
                    <div className="camplist_view">
                      <span className="camp_name">Name</span>
                      <span className="camp_value">{props.campaign.name}</span>
                    </div>
                  </div>
                  <div class="campaignItem">
                    <div className="camplist_view">
                      <span className="camp_name">Brand</span>
                      <span className="camp_value">{props.campaign.brand}</span>
                    </div>
                  </div>
                  <div class="campaignItem">
                    <div className="camplist_view">
                      <span className="camp_name">Product</span>
                      <span className="camp_value">{props.campaign.product}</span>
                    </div>
                  </div>
                </div>
                <div className="campContainer">
                  <div class="campaignItem">
                    <div className="camplist_view">
                      <span className="camp_name">Taxes</span>
                      <span className="camp_value">{props.campaign.taxes}</span>
                    </div>
                  </div>
                  <div class="campaignItem">
                    <div className="camplist_view">
                      <span className="camp_name">Audio Length</span>
                      <span className="camp_value">{props.campaign.audioLength}</span>
                    </div>
                  </div>
                  <div class="campaignItem">
                    <div className="camplist_view">
                      <span className="camp_name">Audio Cost</span>
                      <span className="camp_value">{props.campaign.audioCost}</span>
                    </div>
                  </div>
                </div>
                <div className="campContainer">
                  <div class="campaignItem">
                    <div className="camplist_view">
                      <span className="camp_name">Discount</span>
                      <span className="camp_value">{props.campaign.discount}</span>
                    </div>
                  </div>
                  <div class="campaignItem">
                    <div className="camplist_view">
                      <span className="camp_name">Audio Discount</span>
                      <span className="camp_value">{props.campaign.audioDiscount}</span>
                    </div>
                  </div>
                  <div class="campaignItem">
                    <div className="camplist_view">
                      <span className="camp_name">Audio Total Cost</span>
                      <span className="camp_value">{props.campaign.audioTotalCost}</span>
                    </div>
                  </div>
                </div>
                <div className="campContainer">
                  <div class="campaignItem">
                    <div className="camplist_view">
                      <span className="camp_name">Total Cost</span>
                      <span className="camp_value">{props.campaign.totalCost}</span>
                    </div>
                  </div>
                  <div class="campaignItem">
                    <div className="camplist_view">
                      <span className="camp_name">Pay Id</span>
                      <span className="camp_value">{props.campaign.payId}</span>
                    </div>
                  </div>
                </div>
                <div class="submit-billing submit-slots camp-next">
                  <button
                    onClick={() => {
                      props.firstPage();
                    }}
                  >
                    BACK
                  </button>
                  <button>Approve</button>
                  <button>Reject</button>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

const EditCampaigns = reduxForm({
  form: "editCampaign",
})(EditCampaign);

export default EditCampaigns;



// WEBPACK FOOTER //
// ./web/components/admin/manageCampaign/editCampaign.js